/**
 * more-info
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

export default sb => {
    let moreInfoTrigger;
    let moreInfoPanel;

    const toggleMoreInfo = function toggleMoreInfo(e) {
        e.preventDefault();

        if (moreInfoTrigger[0].value === "More information") {
            moreInfoPanel.css("display", "block");
            moreInfoTrigger[0].value = "Less information";
        } else {
            moreInfoPanel.css("display", "none");
            moreInfoTrigger[0].value = "More information";
        }
    };

    return {
        init() {
            moreInfoTrigger = sb.find("#more_info_trigger");
            moreInfoPanel = sb.find("#more_info_panel");

            moreInfoTrigger[0].value = "More information";

            sb.addEvent(moreInfoTrigger, "click", toggleMoreInfo);
        },
        destroy() {
            sb.removeEvent(moreInfoTrigger, "click", toggleMoreInfo);

            moreInfoPanel = null;
            moreInfoTrigger = null;
        }
    }
}
